<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .text-panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(44px);
    padding: utils.in_rem(56px);
    background-image: url("../../../../../assets/img/dialer-promo/bg.png");
    background-position: center;
    background-size: cover;

    .requested-text {
      @include mixins.body2();
    }
  }
</style>

<script>
  import { notetakerRequestedStore } from "../../../../../api-stores/meetings-store";
  import BulletPoints from "./promoComponents/BulletPoints.svelte";
  import MainText from "./promoComponents/MainText.svelte";
  import RegisterButton from "./promoComponents/RegisterButton.svelte";
</script>

<div class="text-panel">
  <MainText />
  <BulletPoints />
  {#if $notetakerRequestedStore}
    <span class="requested-text">
      Free trial of Notetaker has been requested
    </span>
  {:else}
    <RegisterButton />
  {/if}
</div>
